import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export default class I18nRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getLiterals() {
    throw new Error('[I18nRepository#getLiterals] must be implemented')
  }
}
